import React from 'react';
import { Alert, AlertTitle } from "@material-ui/lab";
import Snackbar from '@mui/material/Snackbar';


export interface ICommonAlert {
    openAlert?: boolean;
    autoHideDuration?: number;
    handleAlertClose?: any;
    horizontal?: any;
    vertical?: any;
    severity: any;
    title?: string;
    description: string,
    variant:any
}

const CommonAlert = (props: ICommonAlert) => {

    const {
        openAlert,
        autoHideDuration,
        handleAlertClose,
        horizontal,
        vertical,
        severity,
        title,
        description,
        variant
    } = props

    return (
        <div>
            <Snackbar
                open={openAlert}
                autoHideDuration={autoHideDuration ? autoHideDuration : 5000}
                onClose={handleAlertClose}
                anchorOrigin={{ horizontal: horizontal ? horizontal : "right", vertical: vertical ? vertical : "bottom" }}
            >
                <Alert
                    severity={severity}
                    style={{ width: "90%" }}
                    variant={variant ? variant : "filled"}
                >
                    <AlertTitle>
                        <strong>{title}</strong>
                    </AlertTitle>
                    {description}
                </Alert>
            </Snackbar>
        </div>
    );
}

export default CommonAlert;
